// extracted by mini-css-extract-plugin
module.exports = {"BooksTextButton":"BooksTextButton_BooksTextButton__1H59U"};